import { useNavigate } from 'react-router-dom';
import React from 'react';
import { PATH_ONBOARDING } from 'src/constants/spa-routes';
import { ProductsType } from 'src/constants/products';

export const OnboardingHeadLastStep = () => {
  const navigate = useNavigate();

  const back = () => {
    navigate(`${PATH_ONBOARDING.ROOT}/4?type=${ProductsType.customer}`, {
      replace: true,
    });
  };

  return (
    <div className={'flex flex-row w-full justify-between'}>
      <div>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="33"
          height="20"
          viewBox="0 0 33 20"
          fill="none"
        >
          <path
            d="M9.99343 0.000102564C7.35999 0.000102678 4.77036 1.05366 2.90824 2.92902C1.04613 4.80437 -3.59335e-07 7.3479 -4.41153e-07 10.0001C-5.2297e-07 12.6522 1.04613 15.1957 2.90824 17.0711C4.77036 18.9464 7.36 20 9.99343 20L9.99343 10.0001L9.99343 0.000102564Z"
            fill="#05050D"
          />
          <path
            d="M22.7539 0C28.2731 0 32.748 4.47718 32.748 10C32.748 15.5228 28.2731 20 22.7539 20C17.2348 19.9999 12.7608 15.5227 12.7607 10C12.7607 4.47727 17.2348 0.000142861 22.7539 0ZM22.7324 5.9043C20.4746 5.9043 18.6436 7.73581 18.6436 9.99512C18.6436 12.2545 20.4746 14.0859 22.7324 14.0859C24.9902 14.0858 26.8203 12.2544 26.8203 9.99512C26.8203 7.73589 24.9901 5.90444 22.7324 5.9043Z"
            fill="#05050D"
          />
        </svg>
      </div>
      <div className={'flex flex-col gap-1.5'}>
        <div
          onClick={back}
          className={'text-[#3F60B3] text-xs font-medium cursor-pointer hover:underline'}
        >
          ← Back
        </div>
      </div>
    </div>
  );
};
